import {
  BET_AMOUNT_CHANGE_STATE,
  SPIN_COUNT_CHANGE_STATE,
  SPIN_AMOUNT,
  SPIN_AMOUNT_ACTIVE,
  AUTO_SPIN_COUNTS,
  AUTO_SPIN_INDEX, AUTO_SPIN_BUTTON_STATE,
} from '../../stateManagment/gameState';

export class GamePadHelper {
  disabledAmountChangeState() {
    BET_AMOUNT_CHANGE_STATE.next(false);
  }

  enableAmountChangeState() {
    BET_AMOUNT_CHANGE_STATE.next(true);
  }

  disabledSpinCountChangeState() {
    SPIN_COUNT_CHANGE_STATE.next(false);
  }

  enableSpinCountChangeState() {
    SPIN_COUNT_CHANGE_STATE.next(true);
  }

  incrementBetAmount() {
    const max = SPIN_AMOUNT.getValue().length - 1;
    const current = SPIN_AMOUNT_ACTIVE.getValue();
    if (current < max) {
      SPIN_AMOUNT_ACTIVE.next(current + 1);
    }
  }

  decrementBetAmount() {
    const min = 0;
    const current = SPIN_AMOUNT_ACTIVE.getValue();
    if (current > min) {
      SPIN_AMOUNT_ACTIVE.next(current - 1);
    }
  }

  incrementAutoSpin() {
    const max = AUTO_SPIN_COUNTS.getValue().length - 1;
    const current = AUTO_SPIN_INDEX.getValue();
    if (current < max) {
      AUTO_SPIN_INDEX.next(current + 1);
    }
  }

  decrementAutoSpin() {
    const min = 0;
    const current = AUTO_SPIN_INDEX.getValue();
    if (current > min) {
      AUTO_SPIN_INDEX.next(current - 1);
    }
  }

  disableAutoSpin() {
    AUTO_SPIN_BUTTON_STATE.next(false);
  }

  enableAutoSpin() {
    AUTO_SPIN_BUTTON_STATE.next(true);
  }

  get autoSpinButtonState() {
    return AUTO_SPIN_BUTTON_STATE.getValue();
  }
}

export const gamePadHelper = new GamePadHelper();
